import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/protix.webp';
import screenshot_target from '../../../images/letterfunnel/maikovandermeer.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Maiko van der Meer"
      firstname="Maiko"
      companyname="Protix"
      competition="Innovafeed en Tebrio"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/maikovandermeer.js